import downArrow from '@/assets/downArrow.svg'
import upArrow from '@/assets/upArrow.svg'
import { RootState } from '@/reducers/store'
import {
    useUpdateAccordionSection,
    useUpdateCollapsedAll,
} from '@/state/survey/poaSurveySlice'
import { memo } from 'react'
import { useSelector } from 'react-redux'

interface AccordionProps {
    level?: 'parent' | 'child'
    section: string
}

const Accordion: React.FC<AccordionProps> = memo(({ level, section }) => {
    const { isLoading, sections } = useSelector(
        (state: RootState) => state.poaSurvey
    )

    const updateCollapsedAll = useUpdateCollapsedAll()
    const updateAccordionSection = useUpdateAccordionSection()

    const isActive = sections?.[section]?.isActive ?? false

    return (
        <>
            {!isLoading && level === 'parent' && (
                <div className="accordian dropdown-wrap ml-5">
                    <div className="dropdown-label">All</div>
                    <div className="icon">
                        <img
                            src={downArrow}
                            alt="Down Arrow"
                            className="icon-img cursor-pointer"
                            onClick={() => {
                                updateCollapsedAll(true)
                            }}
                        />
                    </div>
                    <div className="separator"></div>
                    <div className="icon">
                        <img
                            src={upArrow}
                            alt="Up Arrow"
                            className="icon-img cursor-pointer"
                            onClick={() => {
                                updateCollapsedAll(false)
                            }}
                        />
                    </div>
                </div>
            )}

            {!isLoading && level === 'child' && (
                <div className="icon dropdown-wrap-child">
                    <img
                        src={isActive ? upArrow : downArrow}
                        alt={isActive ? 'Up Arrow' : 'Down Arrow'}
                        className="w-4 h-2 cursor-pointer"
                        onClick={() => {
                            updateAccordionSection(section)
                        }}
                    />
                </div>
            )}
        </>
    )
})

export default Accordion
